import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class MaterialService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getMateriaisDisponiveis() {
        return this.http.get(`${SCAMP_API.accountApiV1}/materiais-disponiveis`, { headers: this.account.composeHeaders() });
    }
}
MaterialService.ngInjectableDef = i0.defineInjectable({ factory: function MaterialService_Factory() { return new MaterialService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: MaterialService, providedIn: "root" });
